import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatCardModule } from '@angular/material/card';

//COMPONENTS
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { CustomizerComponent } from './customizer/customizer.component';
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';

import { S3FileUploadComponent } from './s3-file-upload/s3-file-upload.component';
import { PlayerListComponent } from './player-list/player-list.component';
import { SelectorComponent } from './selector/selector.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { VimeoPreviewComponent } from './vimeo-preview/vimeo-preview.component';
import { PdfPreviewComponent } from './pdf-preview/pdf-preview.component';
import { JsonPreviewComponent } from './json-preview/json-preview.component';
import { SharedTableComponent } from './shared-table/shared-table.component';
import { LazySelectComponent } from './lazy-select/lazy-select.component';
import { UploadComponent } from './upload/upload.component';
import { NavigatorModule } from './navigator/navigator.module';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';

// import { FileUploader } from 'ng2-file-upload';

//DIRECTIVES
import { ToggleFullscreenDirective } from './directives/toggle-fullscreen.directive';
import { SidebarDirective } from './directives/sidebar.directive';
import { SidebarLinkDirective } from './directives/sidebarlink.directive';
import { SidebarListDirective } from './directives/sidebarlist.directive';
import { SidebarAnchorToggleDirective } from './directives/sidebaranchortoggle.directive';
import { SidebarToggleDirective } from './directives/sidebartoggle.directive';
import { LetModule } from './directives/let.directive';
import { DatatableModule } from './datatable/datatable.module';
import { DatatableComponent } from './datatable/datatable.component';
import { BulkUploadComponent } from './bulk-upload/bulk-upload.component';
import { MatIconModule } from '@angular/material/icon';
import { ImagePreviewComponent } from './image-preview/image-preview.component';

@NgModule({
  exports: [
    CommonModule,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    CustomizerComponent,
    UploadComponent,
    BulkUploadComponent,
    NotificationSidebarComponent,
    ToggleFullscreenDirective,
    SidebarDirective,
    NgbModule,
    TranslateModule,
    SharedTableComponent,
    DatatableComponent,
    LazySelectComponent,
    S3FileUploadComponent,
    PlayerListComponent,
    SelectorComponent,
    CommonModule,
    LetModule,
    NavigatorModule,
  ],
  imports: [
    MatProgressSpinnerModule,
    PdfViewerModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    CommonModule,
    // FileUploadModule,
    NgbModule,
    TranslateModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatFormFieldModule,
    MatSelectInfiniteScrollModule,
    MatInputModule,
    MatIconModule,
    NgxMatSelectSearchModule,
    MatCardModule,
    NgScrollbarModule,
    DatatableModule,
  ],
  declarations: [
    UploadComponent,
    BulkUploadComponent,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    CustomizerComponent,
    NotificationSidebarComponent,
    ToggleFullscreenDirective,
    SidebarDirective,
    SidebarLinkDirective,
    SidebarListDirective,
    SidebarAnchorToggleDirective,
    SidebarToggleDirective,
    SharedTableComponent,
    LazySelectComponent,
    S3FileUploadComponent,
    PlayerListComponent,
    SelectorComponent,
    ConfirmationModalComponent,
    PdfPreviewComponent,
    VimeoPreviewComponent,
    JsonPreviewComponent,
    ImagePreviewComponent,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', subscriptSizing: 'dynamic' },
    },
  ],
})
export class SharedModule {}
